import { render, staticRenderFns } from "./AppContactInformationDlg.vue?vue&type=template&id=9a448a4c&scoped=true"
import script from "./AppContactInformationDlg.vue?vue&type=script&lang=js"
export * from "./AppContactInformationDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a448a4c",
  null
  
)

export default component.exports